import { UploadStickerField } from './UploadStickerField'
import { withUploadStickerField } from './withUploadStickerField'

const ConnectedUploadStickerField = withUploadStickerField(UploadStickerField)

export { ConnectedUploadStickerField as UploadStickerField }
